/* global window, moeditor, Intercom */
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import Toggle from 'material-ui/Toggle';
import { updateMobileView } from 'crazyEditor/redux/modules/editor/editor';
import { setSelectedElementIds, clearHoveredElementId } from 'crazyEditor/redux/modules/stage/stage';
import { PAGE_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import { setMobileOptimized } from 'crazyEditor/redux/modules/template/template';
import { VIEW_MODES, VIEW_MODES_SWITCH_ID } from 'crazyEditor/core/constants/editorConstants';
import RadioButton from 'material-ui/RadioButton';
import Radium from 'radium';
import {eventOnFirstTime} from 'shared/helpers/analyticsHelper';
import {setViewMode} from 'crazyEditor/core/utils/stageUtils';
import globalControlStyles from '../GlobalControlsStyles';
import styles from './ViewModesStyles';
import {Tabs, Tab} from 'material-ui/Tabs';
import * as Colors from 'material-ui/styles/colors';
import { NAV_HEIGHT } from 'Layout/MyAccountLayout/dimensions';
import Popover from '@material-ui/core/Popover';
const MobileIcon = ({color}) => <FontIcon color={color} style={styles.menuIconStyle} className="material-icons">smartphone</FontIcon>;
const DesktopIcon = ({color}) => <FontIcon color={color} style={styles.menuIconStyle} className="material-icons">desktop_windows</FontIcon>;

@connect(
  (state) => ({
    isQuickPreviewMode: state.editor.isQuickPreviewMode,
    isDesktopView: state.editor.isDesktopView,
    viewMode: state.editor.viewMode,
    mobileOptimized: state.template.mobileOptimized
  }),
  {setViewMode, setMobileOptimized, updateMobileView, setSelectedElementIds, clearHoveredElementId}
)
@Radium
export default class ViewModes extends Component {
  constructor(props) {
    super(props);

    this.switchToDesktopView = this.switchToDesktopView.bind(this);
    this.switchToMobileView = this.switchToMobileView.bind(this);
  }

  state = {
    viewModesPopoverOpened: false
  };

  switchToDesktopView() {
    const { setSelectedElementIds, clearHoveredElementId } = this.props;
    this.closeViewModesPopover();
    setSelectedElementIds(PAGE_ELEMENT_ID);
    clearHoveredElementId();
    setViewMode(VIEW_MODES.DESKTOP);
  }

  switchToMobileView() {
    const { updateMobileView, setSelectedElementIds, clearHoveredElementId } = this.props;
    this.closeViewModesPopover();
    setSelectedElementIds(PAGE_ELEMENT_ID);
    clearHoveredElementId();
    updateMobileView();
    setViewMode(VIEW_MODES.MOBILE);
    eventOnFirstTime('Mobile View - First Clicked');
  }

  openViewModesPopover = (event) => {
    this.setState({
      viewModesPopoverOpened: true,
      viewModesAnchorEl: event.currentTarget
    });
  };

  closeViewModesPopover = () => {
    this.setState({
      viewModesPopoverOpened: false
    });
  };

  renderQuickPreviewViewModes() {
    const {viewMode, mobileOptimized} = this.props;
    return (
      <Tabs
        value={viewMode}
        style={{height: `${NAV_HEIGHT}px`, width: 300}}
        tabItemContainerStyle={{backgroundColor: Colors.transparent}}
      >
        <Tab buttonStyle={{height: `${NAV_HEIGHT}px`}} label={<span style={{height: `${NAV_HEIGHT}px`, display: 'flex', alignItems: 'center'}}><DesktopIcon color={Colors.white}/> desktop</span>} value={VIEW_MODES.DESKTOP} onActive={this.switchToDesktopView}/>
        <Tab disabled = {!mobileOptimized} buttonStyle={{opacity: !mobileOptimized ? 0.5 : undefined, height: `${NAV_HEIGHT}px`}} label={<span style={{height: `${NAV_HEIGHT}px`, display: 'flex', alignItems: 'center'}}><MobileIcon color={Colors.white}/> mobile</span>} value={VIEW_MODES.MOBILE} onActive={this.switchToMobileView}/>
      </Tabs>
    );
  }

  render() {
    const { isQuickPreviewMode, setMobileOptimized, mobileOptimized, isDesktopView } = this.props;

    if (isQuickPreviewMode) {
      return this.renderQuickPreviewViewModes();
    }

    return (
      <span id={VIEW_MODES_SWITCH_ID} style={styles.container}>
        <FlatButton style={globalControlStyles.buttonStyle}
                    onClick={this.openViewModesPopover}
                    children={<span style={{display: 'flex', alignItems: 'center', paddingRight: '12px', paddingLeft: '2px', fontSize: '14px'}}><FontIcon style={globalControlStyles.iconButtonStyle} className="material-icons">{isDesktopView ? 'desktop_windows' : 'smartphone'}</FontIcon>{isDesktopView ? 'DESKTOP VIEW' : 'MOBILE VIEW'}</span>}
        />

        <Popover
          open={this.state.viewModesPopoverOpened}
          anchorEl={this.state.viewModesAnchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          transformOrigin={{horizontal: 'left', vertical: 'top'}}
          onClose={this.closeViewModesPopover}
        >
          <div onClick={this.switchToDesktopView} style={styles.radioMenuItemStyle} key={VIEW_MODES.DESKTOP}>
            <RadioButton
              value={VIEW_MODES.DESKTOP}
              checked={isDesktopView}
              style={styles.radioButtonStyle}
            />
            <DesktopIcon/>
            Desktop View
          </div>
          <div onClick={this.switchToMobileView} style={styles.radioMenuItemStyle} key={VIEW_MODES.MOBILE}>
            <RadioButton
              value={VIEW_MODES.MOBILE}
              checked={!isDesktopView}
              style={styles.radioButtonStyle}
            />
            <MobileIcon/>
            Mobile View
          </div>
          <Divider />
          <MenuItem style={styles.toggleMenu}
                    onClick={() => setMobileOptimized(!mobileOptimized)}
                    children={
                      <div>
                        <Toggle labelPosition="right"
                                label="Make listing mobile friendly"
                                labelStyle={{textIndent: 10}}
                                defaultToggled={mobileOptimized} />
                        <div style={styles.toggleMenuHelpText}>{mobileOptimized ? 'Turned on - customers see mobile version on mobile devices' : 'Turned off - customers see desktop version on mobile devices'}</div>
                      </div>
                    }
          />
        </Popover>
      </span>
    );
  }
}
